import { ILibraryOpeningHours } from '@/lib/fragments/libraryOpeningHours';
import { generateCorrectSlug } from '../generate-correct-slug';
import { ILibraryOpeningHoursException } from '@/lib/fragments/libraryOpeningHoursException';
import { IMeetingPlacePageTenantList } from '@/lib/fragments/meetingPlacePageTenantList';
import { IMeetingPlacePageTenantShopList } from '@/lib/fragments/meetingPlacePageTenantShopList';
import { IMeetingPlacePageTenantFoodBeverageList } from '@/lib/fragments/meetingPlacePageTenantFoodbeverageList';
import { IMeetingPlacePageTenantEntertainmentList } from '@/lib/fragments/meetingPlacePageTenantEntertainmentList';
import { PageContext } from '@/templates/page-context.interface';
import { IMeetingPlacePageHomeMinifiedExtendedTenantOpeningHours } from '@/lib/fragments/meetingPlacePageHome-minified';

export interface tenantListMeetingPlacePageHome {
  meetingPlace: {
    timezone: string;
    integrationId: string;
    businessUnitCode: string;
    showSocialShare: boolean;
    openingHours: ILibraryOpeningHours;
    openingHoursExceptions: ILibraryOpeningHoursException[];
    tenantListPage?: IMeetingPlacePageTenantList;
    tenantShopListPage: IMeetingPlacePageTenantShopList;
    tenantFoodBeverageListPage?: IMeetingPlacePageTenantFoodBeverageList;
    tenantEntertainmentListPage?: IMeetingPlacePageTenantEntertainmentList;
  };
}

export const extractTenantData = (
  homepage:
    | IMeetingPlacePageHomeMinifiedExtendedTenantOpeningHours
    | tenantListMeetingPlacePageHome
    | null,
  node_locale: string,
) => {
  if (!homepage) {
    return [];
  }

  const shopList =
    homepage?.meetingPlace?.tenantShopListPage?.shopItemsCollection?.items;
  const foodBevList =
    homepage?.meetingPlace?.tenantFoodBeverageListPage
      ?.foodBeverageItemsCollection?.items;
  const entertainmentList =
    homepage?.meetingPlace?.tenantEntertainmentListPage
      ?.entertainmentItemsCollection?.items;
  const tenantList =
    homepage?.meetingPlace?.tenantListPage?.tenantsCollection?.items || [];

  const allItems = [
    ...(shopList ? shopList : []),
    ...(foodBevList ? foodBevList : []),
    ...(entertainmentList ? entertainmentList : []),
  ].filter(Boolean);

  tenantList.forEach((tenant: any) => {
    if (!allItems.some((item) => item?.sys?.id === tenant?.sys?.id)) {
      allItems.push(tenant);
    }
  });

  return allItems.map((tenant) => {
    const slug = tenant?.slug || '';

    const tenantSlug = generateCorrectSlug(
      {
        // customizedSlug: tenant.customizedSlug,
        name: tenant?.name,
        node_locale: node_locale,
        slug,
      },
      '',
    );

    return {
      name: tenant?.name || tenant?.brand?.name || '',
      openingHours: tenant?.openingHours ?? null,
      openingHoursExceptions:
        tenant?.openingHoursExceptionsCollection?.items ?? null,
      timezone: homepage?.meetingPlace?.timezone ?? '',
      slug: tenantSlug,
      __typename: tenant?.__typename || '',
    };
  });
};

